import { isEmpty } from 'lodash'
import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'

import Typography from '../../../../components/Typography/Typography'
import InfoWindow from '../../../../components/Windows/InfoWindow/InfoWindow'
import OrderWindow from './components/OrderWindow/OrderWindow'

import hocTicketsAndReserv from './hocTicketsAndReserv'

import './TicketsAndReserv.scss'

const TicketsAndReserv = ({ sectionRef, tickets, reservations, loading, payReservation }) => {
    const intl = useIntl()

    return (
        <Container fluid className={'tickets-and-reserv d-flex flex-column'} ref={sectionRef}>
            <Typography variant={'h2'}>{intl.formatMessage({ id: 'userProfile.ticketsAndReserv.title' })}</Typography>
            {isEmpty(tickets) && isEmpty(reservations) && (
                <InfoWindow
                    color={'white'}
                    description={intl.formatMessage({ id: 'windows.notification.noTicketsReserv' })}
                />
            )}

            {reservations?.map((reservation) => (
                <OrderWindow key={reservation.number} order={reservation} payReservation={payReservation} />
            ))}
            {tickets?.map((ticket) => (
                <OrderWindow key={ticket.number} order={ticket} />
            ))}
        </Container>
    )
}

export default hocTicketsAndReserv(TicketsAndReserv)
